module.exports = __webpack_public_path__ + "static/media/applicationDevelopment-min.32ff4c8b.jpg";